import React from "react";
import { Link } from "react-router-dom";

function GamePage() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 py-10 text-center bg-yellow-50">
      <h1 className="text-4xl text-yellow-700 font-extrabold mb-8 drop-shadow-md">
        🎮 Choose a Fun Game!
      </h1>

      <div className="flex flex-col sm:flex-row sm:flex-wrap gap-6 items-center justify-center w-full max-w-2xl">
        {/* Alphabet Game */}
        <Link
          to="/game/alphabet"
          className="w-full sm:w-auto px-8 py-4 bg-pink-400 hover:bg-pink-500 text-white text-lg font-bold rounded-2xl shadow-lg transition-all duration-300 flex items-center justify-center gap-2"
        >
          🔤 Alphabet Game
        </Link>

        {/* Flashcards Game */}
        <Link
          to="/game/flashcards"
          className="w-full sm:w-auto px-8 py-4 bg-green-400 hover:bg-green-500 text-white text-lg font-bold rounded-2xl shadow-lg transition-all duration-300 flex items-center justify-center gap-2"
        >
          🧠 Flashcards Game
        </Link>

        {/* Word Match Game */}
        <Link
          to="/game/word-match"
          className="w-full sm:w-auto px-8 py-4 bg-blue-400 hover:bg-blue-500 text-white text-lg font-bold rounded-2xl shadow-lg transition-all duration-300 flex items-center justify-center gap-2"
        >
          🧩 Word Match Game
        </Link>
      </div>
    </div>
  );
}

export default GamePage;
